import { render, staticRenderFns } from "./bulk-action.vue?vue&type=template&id=e61a2ecc"
import script from "./bulk-action.vue?vue&type=script&lang=js"
export * from "./bulk-action.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports